import React, { FunctionComponent } from "react";
import { useTranslate } from "../../../helpers";
import PhasedOutPlans from "../HelpDrawers/PhasedOutPlans";
import exclamationIcon from "../../../assets/exclamation.svg";
import { MedigapPlan, getPhasedOutPlanWaiverStatus } from "../utils/plans";

const PhasedOutDisclaimer: FunctionComponent<{
  className?: string;
  plan: MedigapPlan;
}> = ({ className, plan }) => {
  const t = useTranslate();
  const waiverType = getPhasedOutPlanWaiverStatus(plan);

  if (!waiverType) {
    return null;
  }

  let ageDisclaimerId = "medigap.age_disclaimer";

  if (plan.state === "WI") {
    ageDisclaimerId = "medigap.wi_age_disclaimer";
  }

  return (
    <p className={className}>
      <img src={exclamationIcon} className="ds-u-margin-right--1" alt="" />
      <span>
        {t(ageDisclaimerId)} <PhasedOutPlans waiverType={waiverType} />
      </span>
    </p>
  );
};

export default PhasedOutDisclaimer;
